<template>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="产品名称">
                <a-input @keyup.enter="handleQuery" v-model="queryParam.productName" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="产品编号">
                <a-input @keyup.enter="handleQuery" v-model="queryParam.productCode" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="状态">
                <a-select
                  show-search
                  :allowClear="true"
                  v-model="queryParam.status"
                  placeholder="请选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option :value="0">启用</a-select-option>
                  <a-select-option :value="1">禁用</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                    {{ advanced ? '收起' : '展开' }}
                    <a-icon :type="advanced ? 'up' : 'down'" />
                  </a> -->
              </span>
            </a-col>
          </a-row>
          <div>
            <a-button type="primary" @click="handleSub">确认选择</a-button>
          </div>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 增加修改 -->
      <!-- <create-form ref="createForm" :statusOptions="dict.type['sys_enable_disable']" @ok="getList" /> -->
      <!-- <attributeForm ref="attributeForm" @ok="getList" /> -->

      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        hideDefaultSelections="false"
        :row-selection="rowSelection"
        :pagination="false"
        :bordered="tableBordered"
      >
        <div slot="sort" slot-scope="text, record">
          <!-- <a-input-number
            :min="1"
            v-model="record.sort"
            @change="handleChage(record)"
            placeholder="请输入"
            allow-clear
          /> -->
          <a-input-number
            :min="1"
            v-model="record.sort"
            placeholder="请输入"
          />
        </div>
        <!-- <a-table
            slot="expandedRowRender"
            slot-scope="record"
            :columns="innerColumns"
            :pagination="false"
            :data-source="record.modelCalibers"
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          >
            <span slot="operation" slot-scope="text, records">
              <a @click="$refs.attributeForm.init(record.id, records.id)">属性 </a>
            </span>
          </a-table> -->
        <!-- <span slot="status" slot-scope="text, record">
            <dict-tag :options="dict.type['sys_enable_disable']" :value="record.status" />
          </span> -->
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['abm-fix:model:edit']"> 修改 </a>
          <a-divider type="vertical" v-hasPermi="['abm-fix:model:remove', 'abm-fix:model:status']" />
          <a-dropdown v-hasPermi="['abm-fix:model:remove', 'abm-fix:model:status']">
            <a class="ant-dropdown-link" @click="(e) => e.preventDefault()">
              <a-icon type="double-right" />
              更多
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-hasPermi="['abm-fix:model:remove']">
                <a @click="handleDelete(record)" v-hasPermi="['abm-fix:model:remove']"> 删除 </a>
              </a-menu-item>
              <a-menu-item v-hasPermi="['abm-fix:model:status']">
                <a @click="handleDeletes(record)" v-hasPermi="['abm-fix:model:status']">
                  {{ record.status == 0 ? '禁用' : '启用' }}
                </a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
</template>
  
  <script>
import { delObj, publicModel, statusObj, addModel, tenantList } from '@/api/pressure/mode'
//   import CreateForm from './modules/CreateForm'
//   import attributeForm from './modules/attributeForm'
import { tableMixin } from '@/store/table-mixin'
export default {
  name: 'Post',
  components: {
    //   CreateForm,
    //   attributeForm,
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  props: ['tenantId', 'deList'],
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.onSelectChange,
        hideDefaultSelections: false,
        // getCheckboxProps: (record) => ({
        //   props: {
        //     disabled: true, // Column configuration not to be checked
        //     name: record.name,
        //   },
        // }),
      }
    },
  },
  data() {
    return {
      list: [],
      tableList: [],
      innerColumns: [
        { title: '规格名称', dataIndex: 'name', key: 'name', width: '25%' },
        { title: '规格编号', dataIndex: 'code', key: 'code', width: '25%' },
        { title: '排序号', dataIndex: 'sort', key: 'sort', width: '25%' },
        {
          title: '操作',
          dataIndex: 'operation',
          key: 'operation',
          width: '25%',
          scopedSlots: { customRender: 'operation' },
        },
      ],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 8,
        postCode: undefined,
        postName: undefined,
        status: undefined,
      },
      columns: [
        {
          title: '产品名称',
          dataIndex: 'productName',
          align: 'center',
        },
        {
          title: '产品编号',
          dataIndex: 'productCode',
          ellipsis: true,
          align: 'center',
        },
        {
          title: '单位',
          dataIndex: 'optionalUnit',
          align: 'center',
        },
        {
          title: '排序',
          dataIndex: 'sort',
          align: 'center',
          scopedSlots: { customRender: 'sort' },
        },
        // {
        //   title: '设备编号',
        //   dataIndex: 'devCode',
        //   ellipsis: true,
        //   align: 'center',
        // },
        // {
        //   title: '租户简称',
        //   dataIndex: 'referredName',
        //   align: 'center',
        // },
      ],
    }
  },
  filters: {},
  created() {
    this.getMo()
    // this.tableList = this.deList
    // let arr = []
    // if (this.deList.length) {
    //   this.devList.forEach((v) => {
    //     arr.push(v.modelId)
    //   })
    // }
    // this.selectedRowKeys=arr
  },
  watch: {
    list(newValue, oldValue) {
      // log
      console.log(newValue, '顶顶顶顶')
      //    this.id
    },
  },
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    getMo() {
      tenantList({ tenantId: this.tenantId }).then((res) => {
        console.log(res, 'sdd的点点滴滴')
        const arr = []
        res.data.forEach(v=>{
            arr.push(v.modelId)
        })
        this.selectedRowKeys = arr
        this.tableList = res.data
        this.getList()
      })
    },
    /** 查询部门列表 */
    getList() {
      this.loading = true
      //   if (this.userType == 0) {
      //     fetchList(this.queryParam).then((response) => {
      //       this.list = response.data.records
      //       this.total = response.data.total
      //       this.loading = false
      //     })
      //   } else {
      //   }
      //    fetchList(this.queryParam).then((response) => {
      //     this.list = response.data.records
      //     this.total = response.data.total
      //     this.loading = false
      //   })
      publicModel(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.list.forEach((v) => {
          this.tableList.forEach((item) => {
            if (v.id == item.modelId) {
              v.sort = item.sort
            }
          })
        })
        this.loading = false
      })
    },
    getRows(props, event) {
      console.log(props)

      props.onExpand(props.record, event)
    },
    handleSub() {
      console.log(this.selectedRowKeys, 'selectedRowKeys')
      const query = {
        addParams: this.tableList,
        tenantId: this.tenantId,
      }
      addModel(query).then((res) => {
        this.$message.success('提交成功', 3)
        this.$emit('backTable')
      })
    },
    /**
     * @param {Object} row 子表格的数据行
     * @param {parentRow} row 父表格行数据
     */
    onGetInnerRow(row, parentRow) {
      console.log(row)
      console.log(parentRow)
    },
    // 点击确定
    onChange(e) {
      console.log(e, '的点点滴滴')
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },

    handleChage(e) {
      console.log(e, '的点点滴滴')
      //   let leg = false
      const index = this.tableList.findIndex((item) => item.modelId == e.id)
      console.log(index, 'indexindexindex')
      console.log(this.tableList, 'this.tableListthis.tableList')
      if (index !== -1) {
        if (e.sort) {
          this.tableList[index].sort = e.sort
        } else {
          this.tableList.splice(index, 1)
          this.selectedRowKeys.splice(index, 1)
          this.$forceUpdate()
        }
      } else {
        if (e.sort) {
          this.tableList.push({ sort: e.sort, modelId: e.id, modelCaliberId: 0, modelCaliberAttributeId: 0 })
          this.selectedRowKeys.push(e.id)
        } else {
          //   this.tableList.push({ sort: e.sort, modelId: e.id, modelCaliberId: 0, modelCaliberAttributeId: 0 })
        }
      }
      console.log(this.tableList, 'this.tableListthis.tableList')
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 200,
        postCode: undefined,
        postName: undefined,
        status: undefined,
      }
      this.handleQuery()
    },
    onShowSizeChange(current, pageSize) {
      console.log(pageSize, '顶顶顶顶ttt')
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      console.log(pageSize, '顶顶顶顶ttt444')

      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
      this.list.forEach((v) => {
        this.tableList.forEach((item) => {
          if (v.id == item.modelId) {
            v.sort = item.sort
          }
        })
      })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      //   console.log(selectedRows,'selectedRowsselectedRowsselectedRows')
      this.ids = this.selectedRows.map((item) => item.id)
      //   let arr=this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
      this.$forceUpdate()
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    // 禁用启用
    handleDeletes(row) {
      var that = this
      // let ids = []
      // if (row.id) {
      //   ids = [row.id]
      // } else {
      //   ids = this.ids
      // }
      const text = row.status === 0 ? '是否要禁用此数据?' : '是否要启用此数据?'
      this.$confirm({
        title: text,
        onOk() {
          return statusObj({ id: row.id }).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('操作成功', 3)
          })
        },
        onCancel() {},
      })
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      let ids = []
      if (row.id) {
        ids = [row.id]
      } else {
        ids = this.ids
      }
      this.$confirm({
        title: '是否确认删除此数据?',
        onOk() {
          return delObj(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {},
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'system/post/export',
            {
              ...that.queryParam,
            },
            `post_${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>
  